import { render } from "./DemandTemplateDetailsSectionDemand.vue?vue&type=template&id=173646cc"
import script from "./DemandTemplateDetailsSectionDemand.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateDetailsSectionDemand.vue?vue&type=script&lang=ts"
script.render = render

export default script